import { render, staticRenderFns } from "./iconSofaBed.vue?vue&type=template&id=0f6d6ed8"
import script from "./iconSofaBed.vue?vue&type=script&lang=js"
export * from "./iconSofaBed.vue?vue&type=script&lang=js"
import style0 from "./iconSofaBed.vue?vue&type=style&index=0&id=0f6d6ed8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports